import { Component, OnInit, OnDestroy } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-testimonials",
  templateUrl: "./testimonials.component.html",
  styleUrls: ["./testimonials.component.scss"]
})
export class TestimonialsComponent implements OnInit, OnDestroy {  // ← ADD OnDestroy
  carouselReady = false;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    nav: false,
    navSpeed: 700,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0:   { items: 1 },
      400: { items: 1 },
      740: { items: 1 },
      940: { items: 1 }
    }
  };

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      this.carouselReady = true;
    }, 0);
  }

  ngOnDestroy() {
    this.carouselReady = false;  // collapses *ngIf before carousel's own ngOnDestroy runs
  }
}